var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherlogoscarlet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 261.1 300",
    style: {
      enableBackground: "new 0 0 261.1 286.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#c64147;}\n\t.st1{fill:#682145;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,204.2c-19,7.1-38.1,12.7-57.1,17c33.5,37.7,81.1,55.3,133.4,29l0.4-1.9c4.2-30.2,3.7-42.8,0.7-62.5 S146.9,69.2,127.1,36.1C112.9,12.3,64.7-10.7,23.3,5.3c-2.5,1-4.6,2.8-5.8,5.2C-7.9,59.8-4,122.9,18.7,173.7 C45.1,187.8,74.6,198.1,106,204.2L106,204.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.8,181.4l-17,8.1c31.5,65.5,99,88.9,134.1,96.7l13.2-16.5C233.4,264.8,161.8,245.9,130.8,181.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherlogoscarlet);
export default __webpack_public_path__ + "static/media/feather logo scarlet.3a4611dfab8043ef49bdc8eeb4152e31.svg";
export { ForwardRef as ReactComponent };